import React, { lazy, Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { StyledEngineProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material';

import Loader from '../components/_Partials/Loader'

const LazyHeader = lazy(() => import('../components/_Partials/Header'));
const LazyFooter = lazy(() => import('../components/_Partials/Footer'));


const Main = () => {
    return (
        <Suspense fallback={<Loader />}>
            <StyledEngineProvider injectFirst>
                <CssBaseline />
                <LazyHeader />
                <Outlet />
                <LazyFooter />
            </StyledEngineProvider>
        </Suspense>
    )
}

export default Main;